import{createOrgScope as e}from"./create-org-scope.mjs";const t=(t,n,...r)=>n===void 0?Object.freeze([`app`,t,...r]):Object.freeze([...e(n),`app`,t,...r]);export{t as createAppScope};
//# sourceMappingURL=create-app-scope.mjs.map